import { FormField } from "@repo/skapa";
import { Input } from "@repo/skapa";
import "react-datepicker/dist/react-datepicker.css";

// TODO: console ref warning
interface IDatePickerInputProps {
  label?: string;
  placeholder?: string;
  id?: string;
  autoFocus?: boolean;
  value?: string;
  disabled?: boolean;
  icon?: (...args: any[]) => any;
  onClick?: () => void;
  onChange?: (...args: any[]) => any;
  onFocus?: () => any;
  onBlur?: () => any;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  innerRef?: React.Ref<HTMLInputElement>;
  required?: boolean;
}

export const DatePickerInput = ({
  label,
  autoFocus,
  placeholder,
  id,
  value,
  icon,
  onClick,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  disabled,
  innerRef,
  required,
}: IDatePickerInputProps) => (
  <FormField>
    <Input
      ref={innerRef}
      type="text"
      autoFocus={autoFocus}
      disabled={disabled}
      label={label || ""}
      placeholder={placeholder || ""}
      id={id || placeholder || ""}
      value={value}
      iconPosition="leading"
      onClick={onClick}
      ssrIcon={icon}
      autoComplete="off"
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      required={required}
    />
  </FormField>
);
